module.exports = __webpack_public_path__ + "files/SPIADI2019 - Présentation RICAI.999c1f3400f20c4d3dce5edd3c6267e3.pdf";